export const NAME_SPACE = 'AV_Search/';
export const ROOT_STATE_KEY = 'av_search';
